<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <ul class="breadcrumb breadcrumb-style ">
            <li class="breadcrumb-item">
              <h4 class="page-title">Deleted Users</h4>
            </li>

            <li class="breadcrumb-item bcrumb-2">
              <a href="#" onClick="return false;">Deleted Users!</a>
            </li>

          </ul>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="card">
          <div class="body">
            <div class="responsive_table">
              <div class="materialTableHeader filter-card-height">
                <div class="row">
                  <ul class="header-buttons-left ml-0 ">
                    <li class="dropdown m-l-30">
                      <label for="search-input">
                        <i class="material-icons search-icon">search</i></label>
                      <input placeholder="Search" type="text" #input [(ngModel)]="searchText" (paste)="onPaste($event)"
                        class="browser-default search-field" aria-label="Search box" />
                    </li>
                    <li class="date-background m-l-30">
                      <mat-form-field class="date-input" appearance="outline">
                        <mat-label>Enter a date range</mat-label>
                        <mat-date-range-input [rangePicker]="picker">
                          <input matStartDate matInput placeholder="From" [(ngModel)]="startDate"  [max]="maxDate">
                          <input matEndDate matInput placeholder="To" [(ngModel)]="endDate" [max]="maxDate" [min]="startDate" >
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                      </mat-form-field>
                    </li>
                    <li class="m-l-30">
                      <div class="icon-button-demo m-l-10">
                        <button mat-icon-button color="primary" class="btn-tbl-add" matTooltip="Search">
                          <mat-icon aria-label="Reset all filters" class="col-white"
                            (click)="searchFilters()">arrow_forward</mat-icon>
                        </button>
                      </div>
                    </li>
                    <li>
                      <div class="m-l-30">
                        <button mat-icon-button color="accent" class="btn-tbl-cancel" matTooltip="Reset all filters">
                          <mat-icon aria-label="Reset all filters" class="col-white"
                            (click)="resetFilters()">autorenew</mat-icon>
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="table-img mt-1 d-flex justify-content-end" >
                <img src="./assets/images/banner/xlsx.png" alt="" style="cursor: pointer" (click)="downloadReport('xlsx')" />
              </div>
              <mat-table  [dataSource]="dataSource" matSort matSortActive="email_id" matSortDirection="asc"
                class="mat-cell">
                <ng-container matColumnDef="name">
                  <mat-header-cell *matHeaderCellDef mat-sort-header="name" [ngClass]="'tbl-col-width-per-20'">NAME
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row"
                    [ngClass]="'tbl-col-width-per-20'">
                    <strong> {{row?.firstname}} {{row?.lastname}}</strong>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="username">
                  <mat-header-cell *matHeaderCellDef mat-sort-header="username" [ngClass]="'tbl-col-width-per-20'" >USERNAME
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row"
                    [ngClass]="'tbl-col-width-per-20'">
                    {{row?.username}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="email_id">
                  <mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="'tbl-col-width-per-20'">EMAIL
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row" [ngClass]="'tbl-col-width-per-20'">
                    {{row.email_id}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="latestLoginDate">
                  <mat-header-cell *matHeaderCellDef mat-sort-header="latestLoginDate" [ngClass]="'tbl-col-width-per-20'"> LAST LOGIN
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row"
                    [ngClass]="'tbl-col-width-per-20'">
                    {{row?.latestLoginDate?
                    (row?.latestLoginDate | date:'medium'):"N/A"}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="deleteOn">
                  <mat-header-cell *matHeaderCellDef mat-sort-header="deletedOn" [ngClass]="'tbl-col-width-per-10'"> DELETED ON
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row"
                    [ngClass]="'tbl-col-width-per-10'">
                    {{row?.deleted_on?
                    (row?.deleted_on | date:'medium'):"N/A"}}</mat-cell>
                </ng-container>
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell pt-3 text-muted  " style="width:100vw; text-align:center;">No data found</td>
                </tr>
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns"  matRipple>
                </mat-row>
              </mat-table>
              <div *ngIf="dataSource.isLoading | async" class="tbl-spinner"
                style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                <mat-progress-spinner color="primary" [diameter]="40" mode="indeterminate">
                </mat-progress-spinner>
              </div>

              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell pt-3 text-muted  " style="width:100vw; text-align:center;">No data found</td>
              </tr>

            </div>
            <mat-paginator
              [pageSizeOptions]="dataSource?.totalUsers<=100?[10, 20, 30, 40, 50, 100]:[10, 20, 30, 40, 50, 100,dataSource?.totalUsers]"
              [length]="dataSource?.totalUsers" showFirstLastButtons></mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
